import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

// Fallback used until the API responds, or if it ever fails — the footer
// should never go blank. Mirrors the content this component hardcoded
// before it became data-driven.
const FALLBACK = {
  copyright_text: "© 2026 HouseKeeper by FunSpex Limited. All rights reserved.",
  privacy_policy_url: "https://housekeeper.host/privacy-policy",
  terms_of_service_url: "https://housekeeper.host/terms-of-service",
  support_url: "https://www.housekeeper.host/help",
};

const NewFooter = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  // null while the fetch is in flight — deliberately NOT pre-filled with
  // FALLBACK, otherwise the fallback text flashes on screen for a moment
  // and then gets swapped for the real data once it arrives, which reads
  // as glitchy any time the two differ (e.g. after editing content in
  // admin). FALLBACK is only used if the fetch genuinely fails.
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    // No auth header — this page can be reached logged-out, and the
    // endpoint is intentionally public either way.
    axios
      .get(`${BASE_URL}/api/footer-settings/`)
      .then((response) => setSettings(response.data))
      .catch(() => setSettings(FALLBACK));
  }, [BASE_URL]);

  if (!settings) {
    // Same footprint as the real footer so nothing jumps once it loads.
    return <footer className="bg-white border-t border-gray-200 py-8 px-8 mt-16 h-[84px]" />;
  }

  return (
    <footer className="bg-white border-t border-gray-200 py-8 px-8 mt-16">
      <div className="max-w-7xl mx-auto flex justify-between items-center flex-wrap gap-4">
        <p className="text-gray-500 text-sm">{settings.copyright_text}</p>
        <div className="flex gap-8">
          <Link
            to={settings.privacy_policy_url}
            className="text-[#586989] no-underline text-sm hover:text-[#106A3A]"
          >
            Privacy Policy
          </Link>
          <Link
            to={settings.terms_of_service_url}
            className="text-[#586989] no-underline text-sm hover:text-[#106A3A]"
          >
            Terms of Service
          </Link>
          <Link
            to={settings.support_url}
            className="text-[#586989] no-underline text-sm hover:text-[#106A3A]"
          >
            Support
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
